/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface AdminClimateEntrySTokenDelete$Params {
  sToken: string;
}

export function adminClimateEntrySTokenDelete(http: HttpClient, rootUrl: string, params: AdminClimateEntrySTokenDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, adminClimateEntrySTokenDelete.PATH, 'delete');
  if (params) {
    rb.path('sToken', params.sToken, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    })
  );
}

adminClimateEntrySTokenDelete.PATH = '/admin/climateEntry/{sToken}';
